<template>
  <Modal
    ref="modal"
    class="aviso-sync-mg-modal"
    :small="true"
    :close-button="true"
    @hidden="marcarVisto"
  >
    <h2 class="box__title">Proyectos-cun se renombra a Sync</h2>
    <p class="aviso-sync-mg__texto">
      El link de acceso ahora es <b>sync.mandalagroup.com</b>.
    </p>
    <p class="aviso-sync-mg__texto">
      Todo lo demás se queda como lo tenías, no es necesario que hagas ningún
      cambio.
    </p>
    <div class="aviso-sync-mg__botones">
      <Button @click="$refs.modal.hide()">Entendido</Button>
    </div>
  </Modal>
</template>

<script>
import Button from '@baserow/modules/core/components/Button.vue'
import AuthService from '@baserow/modules/core/services/auth'

// "Ya lo vio" se guarda en completed_guided_tours del perfil, la lista con la
// que el core marca sus recorridos guiados. Es por persona y en el servidor:
// sale una sola vez aunque entre desde otro navegador, y no pide migración.
// El core solo agrega a esa lista (UserHandler.update_user), nunca la pisa, y
// actualizar la cuenta no se puede deshacer con las flechas.
const VISTO = 'aviso-sync-mg'

/**
 * El aviso del cambio de nombre de proyectos-cun a Sync (2026-11-04): un modal
 * a todos, una sola vez. Cerrarlo de cualquier forma (botón, X, Esc, clic
 * fuera) cuenta como visto. Ver .claude/wiki/migracion-sync.md.
 */
export default {
  name: 'AvisoSync',
  components: { Button },
  computed: {
    pendiente() {
      return (
        !!this.$store.getters['auth/getUserId'] &&
        !this.$store.getters['auth/getCompletedGuidedTour'].includes(VISTO)
      )
    },
  },
  watch: {
    pendiente() {
      this.revisar()
    },
  },
  mounted() {
    this.revisar()
  },
  methods: {
    revisar() {
      if (this.pendiente) {
        this.$refs.modal.show()
      }
    },
    async marcarVisto() {
      try {
        const { data } = await AuthService(this.$client).update({
          completed_guided_tours: [VISTO],
        })
        await this.$store.dispatch('auth/forceUpdateUserData', { user: data })
      } catch (error) {
        // Si no se pudo guardar, sale otra vez en la próxima visita: mejor
        // eso que un aviso que nadie vio.
      }
    },
  },
}
</script>

<style lang="scss">
/* Sin colores fijos: build-theme.py invierte cualquier hex del CSS compilado. */
.aviso-sync-mg__texto {
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 12px;
}

.aviso-sync-mg__botones {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
